import { SvgIcon } from '@mui/material'

export const BugIcon = () => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ width: '24px', height: '24px' }}
      fill="none"
    >
      <path
        fill="#E6494F"
        d="M19 7h-2.81c-.45-.8-1.07-1.5-1.82-2L16 3.41 14.59 2l-2.17 2.17a6.002 6.002 0 0 0-2.83 0L7.41 2 6 3.41 7.62 5c-.75.5-1.36 1.21-1.81 2H3v2h2.09c-.06.33-.09.66-.09 1v1H3v2h2v1c0 .34.03.67.09 1H3v2h2.81A6.002 6.002 0 0 0 13 19.65V19c0-2.54 1.61-4.8 4-5.65V13h2v-2h-2v-1c0-.34-.03-.67-.09-1H19V7Zm-6 8H9v-2h4v2Zm0-4H9V9h4v2Zm4.75 11.16-2.75-3L16.16 18l1.59 1.59L21.34 16l1.16 1.41-4.75 4.75Z"
      />
    </SvgIcon>
  )
}
